<template>
    <form class="mt-5">
        <div class="text-center" v-if="isLoading" >
            <loader width="5rem"></loader>
        </div>
        <div v-else>
            <div class="form-group mb-5">
                <label class="label">Ik wil werken volgens de volgende constructie: <sup class="red" title="verplicht">*</sup></label>
                <div class="control">
                    <div class="custom-control custom-radio">
                        <input type="radio" id="work1" name="work" class="custom-control-input" value="1" v-model="form.contractId" @change="$v.form.contractId.$touch">
                        <label class="custom-control-label" for="work1">Als zelfstandige (freelancer)</label>
                    </div>
                    <div class="custom-control custom-radio">
                        <input type="radio" id="work2" name="work" class="custom-control-input" value="2" v-model="form.contractId" @change="$v.form.contractId.$touch">
                        <label class="custom-control-label" for="work2">Een afroepcontract bij Azurity</label>
                    </div>
                    <div class="custom-control custom-radio">
                        <input type="radio" id="work3" name="work" class="custom-control-input" value="3" v-model="form.contractId" @change="$v.form.contractId.$touch">
                        <label class="custom-control-label" for="work3">Via mijn eigen werkgever</label>
                    </div>
                </div>
            </div>
            <transition name="slide">
                <div v-if="needKvK">
                    <div class="form-group" >
                        <label>Vergunningsnummer (ND-nummer)</label>
                        <input :class="['form-control', ($v.form.permitNumber.$dirty) ? ($v.form.permitNumber.$error) ?'is-invalid' : 'is-valid' : '']" type="text" placeholder="ND-" v-model="form.permitNumber" name="permitNumber" id="permitNumber">
                        <div class="invalid-feedback">
                            Vergunningsnummer is verplicht.
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Uittreksel Kamer van Koophandel <sup class="red" title="verplicht">*</sup></label>
                        <div class="input-group" @change="$v.form.kvkDocument.$touch">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Kopie KvK</span>
                            </div>
                            <div class="custom-file">
                                <input type="file"  :class="['custom-file-input form-control', ($v.form.kvkDocument.$dirty) ? ($v.form.kvkDocument.$error) ? 'is-invalid' : 'is-valid' : '']" id="kvkFile" name="kvkDocument" @change="setUploadFile($event, form)">
                                <label class="custom-file-label" for="kvkFile">{{form.kvkDocumentName}}</label>
                            </div>
                        </div>
                        <small><strong>Verplicht!</strong> Alleen doc, docx, pdf, jpg of png documenten kleiner dan 4MB.<br>
                        De verklaring kunt u opvragen bij de KvK via <a href="https://www.kvk.nl" target="_blank">link</a>.</small>
                    </div>
                    <div class="form-group">
                        <label>Verzekeringsgegevens</label>
                        <div class="input-group" @change="$v.form.insuranceDocument.$touch">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Kopie Polis</span>
                            </div>
                            <div class="custom-file">
                                <input type="file"  :class="['custom-file-input form-control', ($v.form.insuranceDocument.$dirty) ? ($v.form.insuranceDocument.$error) ? 'is-invalid' : 'is-valid' : '']" id="insuranceDocument" name="insuranceDocument" @change="setUploadFile($event, form)">
                                <label class="custom-file-label" for="kvkFile">{{form.insuranceDocumentName}}</label>
                            </div>
                        </div>
                        <small>Alleen doc, docx, pdf, jpg of png documenten kleiner dan 4MB.</small>
                    </div>
                </div>
            </transition>
            
            <transition name="slide">
                <div class="form-group mb-5" v-if="isAzurity">
                    <div class="alert alert-secondary text-center" role="alert">
                        Na het voltooien van deze wizard zal iemand van de afdeling personeelszaken zal zo snel mogelijk contact met u op nemen over het verdere proces.
                    </div>
                </div>
            </transition>
            
            <div class="form-group">
                <label>Verklaring Omtrent het Gedrag</label>
                <div class="input-group"  @change="$v.form.vogDocument.$touch">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Kopie VOG</span>
                    </div>
                    <div class="custom-file">
                        <input type="file" :class="['custom-file-input form-control', ($v.form.vogDocument.$dirty) ? ($v.form.vogDocument.$error) ? 'is-invalid' : 'is-valid' : '']" id="vogFile" name="vogDocument" @change="setUploadFile($event, form)">
                        <label class="custom-file-label" for="vogFile">{{form.vogDocumentName}}</label>
                    </div>
                </div>
                <small>Alleen doc, docx, pdf, jpg of png documenten kleiner dan 4MB.<br>
                De verklaring kunt u opvragen bij Justis via <a href="https://www.justis.nl/producten/vog/vog-aanvragen/index.aspx" target="_blank">link</a>.</small>
            </div>

            <transition name="slide">
                <div class="form-group">
                    <label>Legitimatiebewijs <sup class="red" title="verplicht">*</sup></label>
                    <div  class="input-group"  @change="$v.form.identificationDocument.$touch">
                        <div class="input-group-prepend">
                            <span class="input-group-text">Kopie Legitimatie</span>
                        </div>
                        <div class="custom-file">
                            <input type="file" :class="['custom-file-input form-control', ($v.form.identificationDocument.$dirty) ? ($v.form.identificationDocument.$error) ? 'is-invalid' : 'is-valid' : '']" id="documentFile" name="identificationDocument" @change="setUploadFile($event, form)" required >
                            <label class="custom-file-label" for="documentFile">{{form.identificationDocumentName}}</label>
                        </div>
                    </div>
                    <small><strong>Verplicht!</strong> Alleen doc, docx, pdf, jpg of png documenten kleiner dan 4MB.<br>
                    Na het uploaden zullen de legitimatie gegevens conform de AVG worden bewaard.</small>                
                </div>
            </transition>
            
            <transition name="slide">
                <div class="form-group" v-if="isOtherEmployer">
                    <label>Werkgeversverklaring <sup class="red" title="verplicht">*</sup></label>
                    <div class="input-group"  @change="$v.form.employerDocument.$touch">
                        <div class="input-group-prepend">
                            <span class="input-group-text">Kopie Verklaring</span>
                        </div>
                        <div class="custom-file">
                            <input type="file" id="employerFile" :class="['custom-file-input form-control', ($v.form.employerDocument.$dirty) ? ($v.form.employerDocument.$error) ? 'is-invalid' : 'is-valid' : '']" name="employerDocument" @change="setUploadFile($event, form)">
                            <label class="custom-file-label" for="employerFile">{{form.employerDocumentName}}</label>
                        </div>
                    </div>
                    <small><strong>Verplicht!</strong> Alleen doc, docx, pdf, jpg of png documenten kleiner dan 4MB.</small>
                </div>
            </transition>

            <transition name="slide">
                <div v-if="isOtherEmployer || needKvK" class="mt-5" >
                    <h3>WPBR-passen</h3>
                    <pass-manager :passes="form.passes" @add-pass="addPass"></pass-manager>
                    <!--
                    <div class="form-group">
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <select v-model="pass.color" :class="['input-group-text', pass.color]">
                                    <option class="dropdown-item" value="gray" >Grijs</option>
                                    <option class="dropdown-item" value="green" >Groen</option>
                                    <option class="dropdown-item" value="blue" >Blauw</option>
                                    <option class="dropdown-item" value="orange" >Oranje</option>
                                    <option class="dropdown-item" value="yellow" >Geel</option>
                                </select>
                            </div>
                            <div class="custom-file">
                                <input type="file" id="pass" name="pass" :class="['custom-file-input form-control', ($v.pass.document.$dirty) ? ($v.pass.document.$error) ? 'is-invalid' : 'is-valid' : '']" @change="addPass($event)">
                                <label class="custom-file-label" for="pass">{{pass.name}}</label>
                            </div>
                        </div>
                    </div>
                    
                    <div class="form-group">
                        <ul class="list-group">
                            <li :class="['list-group-item', pass.color]" v-for="pass in form.passes" :key="pass.name">
                                {{pass.name}}
                                <button class="btn btn-danger btn-sm" v-if="pass.document != null" @click="removePass(pass)">
                                    <font-awesome-icon icon="trash-alt"></font-awesome-icon>
                                </button>
                            </li>
                        </ul>
                    </div>
                    -->
                </div>
            </transition>

            <div class="form-group mt-5">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" id="generalConditions" v-model="form.generalConditions" :class="['custom-control-input', ($v.form.generalConditions.$dirty) ? ($v.form.generalConditions.$error) ?'is-invalid' : 'is-valid' : '']" @change="$v.form.generalConditions.$touch" required>
                    <label class="custom-control-label" for="generalConditions">Ik ga akkoord met de <router-link tag="a" target="_blank" :to="{ name: 'GeneralConditions' }">Algemene Voorwaarden</router-link> van Azurtiy. <sup class="red" title="verplicht">*</sup></label>
                </div>
                <br>
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" id="correctness" v-model="form.correctness" :class="['custom-control-input', ($v.form.correctness.$dirty) ? ($v.form.correctness.$error) ?'is-invalid' : 'is-valid' : '']" @change="$v.form.correctness.$touch" required>
                    <label class="custom-control-label" for="correctness">Ik verklaar hierbij dat alle informatie naar waarheid en juistheid is ingevuld. Ik ben tevens op de hoogte dat bij het insturen van valse documentatie aangifte wordt gedaan. <sup class="red" title="verplicht">*</sup></label>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import { validationMixin } from 'vuelidate'
import globalFunctions from '@/mixins/globalFunctions'
import wizardFunctions from '@/mixins/wizardFunctions'
import { required, requiredIf } from 'vuelidate/lib/validators'
import PassManager from '@/components/PassManager'
import Loader from '@/components/Loader'

const mustBeTrue = (value) => {
    if(value != null)
    {
        return value
    }
    return true;
};

const fileValidation = (value) => 
{
    if(value != null)
    {
        const ext = value.name.split(".")[value.name.split(".").length - 1];
        const extentions = ['doc', 'docx', 'pdf', 'jpg', 'png', 'jpeg'];
        return value.size <= 4000000 && extentions.indexOf(ext.toLowerCase()) >= 0;
    }
    return true;
}

const validPermit = (value, vm) => {
    if(value == null || value == '')
        return true;

    if(value.startsWith("ND"))
    {
        value = value.replace("-", "").trim();
        let no = value.split("ND")[value.split("ND").length - 1].trim();
        if(no.length == 4)
        {
            no = Number.parseInt(no);
            if(Number.isInteger(no))
            {
                vm.permitNumber = "ND " + no;
                return true;
            }
        }
    }
    return false;
}

export default {
    props: ['clickedNext', 'currentStep'],
    mixins: [validationMixin, globalFunctions, wizardFunctions],
    components: {
        Loader,
        PassManager
    },
    data() {
        return {
            isLoading: false,
            form: {
                contractId: 1,
                permitNumber: null,
                identificationDocument: null,
                identificationDocumentName: 'Kies een document...',
                vogDocument: null,
                vogDocumentName: 'Kies een document...',
                kvkDocument: null,
                kvkDocumentName: 'Kies een document...',
                employerDocument: null,
                employerDocumentName: 'Kies een document...',
                insuranceDocument: null,
                insuranceDocumentName: 'Kies een document...',
                generalConditions: false,
                correctness: false,
                passes: [],
            },
        }
    },
    validations: {
        form: {
            contractId: {
                required
            },
            permitNumber: {
                validPermit
            },
            identificationDocument: {
                required,
                fileValidation
            },
            kvkDocument: {
                required: requiredIf(function() { 
                    return this.needKvK
                }),
                fileValidation
            },
            vogDocument: {
                fileValidation
            },
            insuranceDocument: {
                fileValidation
            },
            employerDocument: {
                required: requiredIf(function() { return this.isOtherEmployer }),
                fileValidation
            },
            generalConditions: {
                required,
                mustBeTrue
            },
            correctness: {
                required,
                mustBeTrue
            },
        }
    },
    mounted() {
        this.getProfile().then(() => {
            this.isLoading = false;
            //this.$v.form.$touch();
            if(!this.$v.$invalid) {
                this.$emit('can-continue', {value: true});
            } else {
                this.$emit('can-continue', {value: false});
            }
            this.init = true;
        });
    },
    methods: {    
        addPass(pass) {
            this.form.passes.push(pass);
        },
        removePass(pass) {
            if(pass.document != null)
                this.form.passes.splice(this.form.passes.indexOf(pass), 1);
        },
        getProfile() {
            this.isLoading = true;
            return this.$http.get('api/Profile/Professional/Wizard/4').then((res) => 
            {
                if(res.data.identificationDocumentName.indexOf("Kies een") < 0)
                    this.form.identificationDocument = this.b64ToFile(res.data.identificationDocument, '', res.data.identificationDocumentName);
                if(res.data.kvkDocumentName.indexOf("Kies een") < 0)
                    this.form.kvkDocument = this.b64ToFile(res.data.kvkDocument, '', res.data.kvkDocumentName);
                if(res.data.vogDocumentName.indexOf("Kies een") < 0)
                    this.form.vogDocument = this.b64ToFile(res.data.vogDocument, '', res.data.vogDocumentName);
                if(res.data.employerDocumentName.indexOf("Kies een") < 0)
                    this.form.employerDocument = this.b64ToFile(res.data.employerDocument, '', res.data.employerDocumentName);
                if(res.data.insuranceDocumentName.indexOf("Kies een") < 0)
                    this.form.insuranceDocument = this.b64ToFile(res.data.insuranceDocument, '', res.data.insuranceDocumentName);

                this.form.identificationDocumentName = res.data.identificationDocumentName;
                this.form.kvkDocumentName = res.data.kvkDocumentName;
                this.form.vogDocumentName = res.data.vogDocumentName;
                this.form.employerDocumentName = res.data.employerDocumentName;
                this.form.insuranceDocumentName = res.data.insuranceDocumentName;
                this.form.generalConditions = res.data.generalConditions;
                this.form.correctness = res.data.correctness;
                this.form.contractId = res.data.contractId;
                this.form.permitNumber = (res.data.permitNumber) ? res.data.permitNumber : null;
                this.form.passes = res.data.passes.map((p) => {
                    return {
                        name: p.thumbnail.fileName,
                        document: p.thumbnail,
                        documentId: p.documentId,
                        color: p.thumbnail.fileName.split("_")[0],
                        permitNumber: p.permitNumber,
                        passNumber: p.passNumber,
                        validTo: p.validTo
                    }
                });
            }).catch(() => {
                this.isLoading = false;
            })
        },
        setProfile() {
            return new Promise((resolve, reject) => {
                this.isLoading = true;

                let formData = new FormData();
                for (var key in this.form) {
                    if(key == "passes")
                    {
                        for (var passKey in this.form[key]) {
                            for (var pass in this.form[key][passKey]) {
                                formData.append("pass_" + passKey + "_" + pass, this.form[key][passKey][pass]);
                            }
                        }
                    } else 
                    {
                        formData.append(key, this.form[key]);
                    }
                }
                
                return this.$http.post('api/Profile/Professional/Wizard/4', formData).then(() => {
                    this.isLoading = false;
                    return resolve();
                }).catch((res) => {
                    this.isLoading = false;
                    return reject(res);
                    //alert('Oops, de laatste stap is niet goed opgeslagen!')
                })
            });
        }
    },
    computed: {
        isOtherEmployer() {
            return this.form.contractId == 3
        },
        isAzurity() {
            return this.form.contractId == 2
        },
        needKvK() {
            return this.form.contractId == 1
        },
    },
    watch: {
        $v: {
            handler: function (val) {
                if(!val.$invalid) {
                    this.$emit('can-continue', {value: true});
                } else {
                    this.$emit('can-continue', {value: false});
                }
            },
            deep: true
        },
        clickedNext(val) {
            if(val === true) {
                this.$v.form.$touch();
            }
        }
    },
}
</script>

<style scoped lang="scss">
label {
    display: inline-block !important;
}
label:not(.custom-control-label) {
    font-weight: bold;
}

/*
.slide-enter-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: ease-in;
   -webkit-transition-timing-function: ease-in;
   -o-transition-timing-function: ease-in;
   transition-timing-function: ease-in;
}

.slide-leave-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
   max-height: 100px;
   overflow: hidden;
}

.slide-enter, .slide-leave-to {
   overflow: hidden;
   max-height: 0;
}
*/
.list-group-item,
.input-group-text
{
    &.gray {
        background-color: #e9ecef;
    }
    &.green {
        color: white;
        background-color: #6AB558;
    }
    &.blue {
        color: white;
        background-color: #568AC6;
    }
    &.orange {
        color: white;
        background-color: #EB6E1E;
    }
    &.yellow {
        background-color: #FFE81A;
    }
}

</style>